import { styled } from '@styles';

export const MgsLogoIcon = styled.img`
  padding-right: 0.5rem;
  width: 5rem;
  height: auto;
`;
